'use client';

import { SelectOptionType } from '@portals/ui-kit';
import { useSearchParams } from 'next/navigation';
import { useCallback } from 'react';
import { APPEAL_COPYRIGHT_ROUTE } from '@portals/portal-routes';

export const useLanguage = () => {
  const pathname = window.location.pathname;
  const searchParams = useSearchParams();

  const changeLanguage = useCallback(
    ({ id }: SelectOptionType) => {
      const newLocale = id;

      const appealUrl = window.location.pathname.match(
        APPEAL_COPYRIGHT_ROUTE.routePath,
      )
        ? APPEAL_COPYRIGHT_ROUTE.routePath
        : '';

      const newPath = `${appealUrl}/${newLocale}`;
      const newUrl = searchParams ? `${newPath}?${searchParams}` : newPath;

      window.location.replace(newUrl);
    },
    [pathname],
  );

  return { changeLanguage };
};
